export default class archives {
  base64: string = '';
  fileName: string = '';
  urlFile: string = '';
}
